import React, { useCallback, useContext } from 'react'
import PropTypes from 'prop-types'
import { get, set, identity } from 'lodash'

import Autocomplete from '../../Autocomplete'
import FilterBarContext from '../context'
import { findSectionElement } from '../utils'

const AutocompleteText = ({ hierarchy, onChange, items }) => {
  const { filters } = useContext(FilterBarContext)
  const value = get(filters, hierarchy)

  const onChangeHandler = useCallback(
    (newValue) => {
      onChange((filters, newSections) => {
        const clonedFilters = { ...filters }
        set(clonedFilters, hierarchy, newValue)

        const clonedNewSections = [...newSections]
        const sectionElement = findSectionElement(clonedNewSections, hierarchy)

        sectionElement.selected = newValue

        return { clonedFilters, clonedNewSections }
      }, hierarchy)
    },
    [onChange, hierarchy]
  )

  return (
    <Autocomplete
      id={hierarchy}
      items={items}
      labelKey='label'
      valueKey='value'
      defaultValue={value}
      onChangeValue={onChangeHandler}
    />
  )
}

AutocompleteText.propTypes = {
  onChange: PropTypes.func,
  hierarchy: PropTypes.arrayOf(PropTypes.string)
}

AutocompleteText.defaultProps = {
  onChange: identity,
  hierarchy: []
}

export default React.memo(AutocompleteText)
